import { produce } from "immer";
import { MICROPHONE_SET, TOGGLE_MIC } from "../actions/types";

const micInitState = {
  id: null,
  name: null,
  isRecording: false,
};

export const microphone = (state = micInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case MICROPHONE_SET:
        draft.id = action.micId;
        draft.name = action.micName;
        break;
      case TOGGLE_MIC:
        draft.isRecording = !draft.isRecording;
        break;
      default:
        break;
    }
  });
